import React from 'react';
import Tooltip from '@src/components/Tooltip';
import SpeakingIcon from '@src/assets/icons/speaking-icon.svg';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DICTIONARY_GUIDE } from '@src/constants/tourGuide';

const OpenDictionary = ({ handleClickButtonDictionary }) => {
  const { t } = useTranslation();

  return (
    <Tooltip arrow title={t('readingWay')} placement="top">
      <Button
        data-id="open-pronunciation-dict"
        id={DICTIONARY_GUIDE.DICTIONARY_BTN}
        className="custom-button-with-icon"
        onClick={handleClickButtonDictionary}
        color="iconPrimary"
      >
        <img
          src={SpeakingIcon}
          alt="Speaking Icon"
          style={{ width: 24, height: 24 }}
        />
      </Button>
    </Tooltip>
  );
};

export default OpenDictionary;
